import React, { useEffect, useState } from 'react'
import NoticeEventTableComponent from '../NoticeEventTableComponent'
import AnimatedTable from '../AnimatedTable'
import telegram_gif from '../../assets/images/telegram_gif.gif'
import telegram_offical_gif from '../../assets/images/telegram_offical_gif.gif'
import domain_gif from '../../assets/images/domain_gif.gif'
import price_money_gif from '../../assets/images/price_money_gif.gif'
import authentication_gif from '../../assets/images/authentication_gif.gif'
import GifImagesSection from '../GifImagesSection'


const TablesGifSection = () => {
    const [noticeTableData, setNoticeTableData] = useState([]);
    const [eventTableData, setEventTableData] = useState([]);
    // const [monthlyWithdrawals, setMonthlyWithdrawals] = useState([]);
    // const [withdrawalsStatus, setWithdrawalsStatus] = useState([]);

    const fetchNotices = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/boards/notices`, {
                headers: {
                    accept: 'application/json'
                }
            });
            const data = await response.json();
            setNoticeTableData(data?.results || []);
            // console.log(results)
        } catch (error) {
            console.error('Error fetching notices:', error);
        }
    };

    const fetchEvents = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/users/events`, {
                headers: {
                    accept: 'application/json'
                }
            });
            const data = await response.json();
            setEventTableData(data?.slice(0, 10));
            // console.log("eeventss::", data)
        } catch (error) {
            console.error("Error fetching events:", error);
        }
    };

    useEffect(() => {
        fetchNotices();
        fetchEvents();
    }, []);
    return (
        <>
            <section className='tables-gif-section'>
                <div className='lg:p-[15px] lg:w-[95%] mx-auto flex justify-between items-start flex-col xl:flex-row'>
                    <div className='mb-2.5 w-full xl:w-[calc(100%_-_390px)] hidden lg:block'>
                        <div className='flex flex-nowrap items-start'>
                            <NoticeEventTableComponent data={noticeTableData} notice={true} event={false} />
                            <NoticeEventTableComponent data={eventTableData} event={true} notice={false} />
                        </div>
                        <div className='flex flex-nowrap items-start'>
                            <AnimatedTable data={monthlyWithdrawals} />
                            <AnimatedTable data={withdrawalsStatus} />
                        </div>
                    </div>
                    {/* <div className='pb-[calc(82px_+_5vw)] px-2.5 lg:p-2.5 mx-auto xl:mx-0 '>
                        <div className='lg:w-[370px]'>
                            {gifData.map((item, index) => (
                                <a key={index} href={item.link_src} target="_blank"><img src={item.img_src} className='my-[5px] lg:mb-[5px]' /></a>
                            ))}
                        </div>
                    </div> */}

                    <GifImagesSection />

                </div>
            </section>
        </>
    )
}

export default TablesGifSection

const monthlyWithdrawals = [
    {
        title: '월간 출금 Top 10',
        list: [
            { name: '1ta***', amount: '536,500,000원' },
            { name: 'kin***', amount: '471,500,000원' },
            { name: 'bit***', amount: '425,400,000원' },
            { name: 'ek***', amount: '388,020,000원' },
            { name: 'kd***', amount: '378,580,000원' },
            { name: '17***', amount: '361,010,000원' },
            { name: 'm***', amount: '300,000,000원' },
            { name: 'rbb***', amount: '293,200,000원' },
            { name: 'go***', amount: '215,600,000원' },
            { name: 'co***', amount: '192,220,000원' }
        ]
    }
]
const withdrawalsStatus = [
    {
        title: '실시간 출금 현황',
        list: [
            { name: 'ne***', amount: '200,000원' },
            { name: 'm***', amount: '30,000원' },
            { name: 'zx***', amount: '100,000원' },
            { name: 'a1***', amount: '11,000,000원' },
            { name: 'nrt***', amount: '130,000원' },
            { name: 'Ho***', amount: '1,270,000원' },
            { name: 'ah***', amount: '500,000원' },
            { name: 'tra***', amount: '200,000원' },
            { name: 'tra***', amount: '900,000원' },
            { name: 'Ho***', amount: '910,000원' },
            { name: 'joo***', amount: '200,000원' },
            { name: 'm***', amount: '2,000,000원' },
            { name: 'Ho***', amount: '660,000원' },
            { name: 'pa***', amount: '500,000원' },
            { name: 'ap***', amount: '3,010,000원' },
            { name: 'jje***', amount: '500,000원' },
            { name: 'dp***', amount: '2,500,000원' },
            { name: 'tjtjr***', amount: '20,000원' },
            { name: 'kim***', amount: '120,000원' },
            { name: 'ho***', amount: '500,000원' },
            { name: 'du***', amount: '900,000원' },
            { name: 'm***', amount: '1,000,000원' },
            { name: 'kim***', amount: '1,300,000원' },
            { name: 'ha***', amount: '20,000원' },
            { name: 'Ho***', amount: '550,000원' },
            { name: 'k0***', amount: '80,000원' },
            { name: 'qu***', amount: '860,000원' },
            { name: 'du***', amount: '1,100,000원' },
            { name: 'm***', amount: '40,000원' },
            { name: 'jje***', amount: '500,000원' },
            { name: 'rla***', amount: '400,000원' },
            { name: 'op***', amount: '1,600,000원' },
            { name: 'jje***', amount: '6,100,000원' },
            { name: 'tjd***', amount: '230,000원' },
            { name: 'ruc***', amount: '200,000원' },
            { name: 'no***', amount: '280,000원' },
            { name: 'uo***', amount: '30,000원' },
            { name: 'm***', amount: '30,000원' },
            { name: 'ss***', amount: '30,000원' },
            { name: 'zz***', amount: '100,000원' },
            { name: 'To***', amount: '360,000원' },
            { name: 'ldg***', amount: '270,000원' },
            { name: 'dk***', amount: '20,000원' },
            { name: 'rla***', amount: '700,000원' },
            { name: 's4***', amount: '50,000원' },
            { name: 'ch***', amount: '4,210,000원' },
            { name: 'dk***', amount: '2,400,000원' },
            { name: 'dp***', amount: '2,800,000원' },
            { name: 'rla***', amount: '250,000원' },
            { name: 'rbt***', amount: '100,000원' },
        ]
    }
]

const gifData = [
    {
        img_src: telegram_gif,
        link_src: '#',
    },
    {
        img_src: telegram_offical_gif,
        link_src: '#',
    },
    {
        img_src: domain_gif,
        link_src: '#',
    },
    {
        img_src: price_money_gif,
        link_src: '#',
    },
    {
        img_src: authentication_gif,
        link_src: '#',
    }
]